(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rubberdukky-preview-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const thumb = event.target.closest('[data-rd-preview-thumb]');
  if (!thumb) return;
  const card = thumb.closest('.rd-next__card');
  if (!card) return;
  const image = card.querySelector('.rd-next__main');
  image.src = thumb.dataset.src;
  image.alt = thumb.dataset.alt;
  card.querySelectorAll('[data-rd-preview-thumb]').forEach(function(button) {
    button.setAttribute('aria-pressed', button === thumb ? 'true' : 'false');
  });
});

  } catch(e) { console.error(e); }
})();
})();
